import React from 'react';
import PropTypes from 'prop-types';
import { Image } from 'react-bootstrap-5';
import IntegrationsModal from './integration_modal';

import contactIcon from '../images/contact_integration.svg';

export default class ContactModal extends React.Component {

  static propTypes = {
    currentDatabase: PropTypes.object,
    databases: PropTypes.array.isRequired,
    shown: PropTypes.bool,
    onCancel: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired
  };

  handleSave = (databaseId) => {
    const { onSave } = this.props;
    onSave(databaseId, 'contacts');
  }

  render() {
    const { currentDatabase, shown, databases, onCancel } = this.props;

    return (
      <IntegrationsModal
        currentDatabase={currentDatabase}
        databases={databases}
        shown={shown}
        title="Connect Contact Sync"
        onCancel={onCancel}
        onSave={this.handleSave}
      >
        <div>
          <div className="mb-3 text-center">
            <div className="bg-body-tertiary border rounded p-2 d-inline-flex">
              <Image alt="Contact integration" height={40} src={contactIcon} width={40} />
            </div>
          </div>
          <span>
            You are about to sync Buildout Contacts with your Google, Office, ICloud or Yahoo account.
            <br/>
            Below, select what database you would like to sync.
          </span>
          <div className="mt-2">
            <strong className="fw-semibold text-danger">
            All contacts created in this database will sync to your Nylas Account.
            </strong>
          </div>
        </div>
      </IntegrationsModal>
    );
  }
}
